import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';

import { ListResult, User } from '../../../entities/index';
import { UserService } from '../../../services/user.service';
import { Log } from '../../../utils/index';

@Component({
  selector: 'app-user-select',
  templateUrl: './user-select.html'
})
export class UserSelectComponent implements OnInit {
  users: User[] = [];
  loading = false;
  totalResult = 0;

  private _btnClass: any = {};

  @Input() set btnClass(value: string) {
      this._btnClass = {};
      this._btnClass[value] = true;
  }

  get btnClassConf(): boolean {
      return this._btnClass;
  }

  @Output() userSelected: EventEmitter<User> = new EventEmitter<User>();

  protected searchTermStream = new Subject<string>();

  search(terms: string) {
    this.searchTermStream.next(terms);
  }

  constructor(protected userService: UserService) {}

  @Log()
  ngOnInit() {
    this.searchTermStream
      .map((terms: string) => {
        this.loading = true;
        return terms;
      })
      .debounceTime(1000)
      .distinctUntilChanged()
      .mergeMap((terms: string) => {
        if (!terms) {
          return Observable.of({'items': [], 'total': 0 });
        } else {
          return this.userService.list(terms, 1, 15);
        }
      })
      .subscribe(
        (result: ListResult<User>) => {
          this.users = result.items;
          this.totalResult = result.total;
          this.loading = false;
        }
      );
  }

  selectUser(user: User) {
    this.userSelected.emit(user);
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/shared/user-select/user-select.component.ts